<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title"><a id="page_1"></a>T<span class="smallcaps">ABLE</span> O<span class="smallcaps">F</span> C<span class="smallcaps">ONTENTS</span></p>
<p class="toc-text"><a href="#/xhtml/fm01">INTRODUCTION</a></p>
<p class="toc-texta"><a href="#/xhtml/fm01"><i>The Search for WomanSpirit</i></a></p>
<p class="toc-text"><a href="#/xhtml/chapter001">PART ONE</a></p>
<p class="toc-texta"><a href="#/xhtml/chapter001">T<span class="smallcaps">HE</span> G<span class="smallcaps">ODDESS</span>: H<span class="smallcaps">ERSTORY</span></a></p>
<p class="toc-texta"><a href="#/xhtml/chapter001"><i>WomanSpirit – Free</i></a></p>
<p class="toc-text"><a href="#/xhtml/chapter002">PART TWO</a></p>
<p class="toc-texta"><a href="#/xhtml/chapter002">T<span class="smallcaps">RANSITION</span> T<span class="smallcaps">IMES</span></a></p>
<p class="toc-texta"><a href="#/xhtml/chapter002"><i>WomanSpirit – Challenged Threatened</i></a></p>
<p class="toc-text"><span href="#/xhtml/chapter003" title="Link target outside of Sample">PART THREE</span></p>
<p class="toc-texta"><span href="#/xhtml/chapter003" title="Link target outside of Sample">T<span class="smallcaps">HE</span> I<span class="smallcaps">NQUISITION</span></span></p>
<p class="toc-texta"><span href="#/xhtml/chapter003" title="Link target outside of Sample"><i>WomanSpirit – Demonized Burnt to Ashes</i></span></p>
<p class="toc-text"><span href="#/xhtml/chapter004" title="Link target outside of Sample">PART FOUR</span></p>
<p class="toc-texta"><span href="#/xhtml/chapter004" title="Link target outside of Sample">A<span class="smallcaps">FTERMATH</span></span></p>
<p class="toc-texta"><span href="#/xhtml/chapter004" title="Link target outside of Sample"><i>WomanSpirit – Rising</i></span></p>
<p class="toc-text"><span href="#/xhtml/end01" title="Link target outside of Sample">NOTES</span></p>
<p class="toc-text"><span href="#/xhtml/end02" title="Link target outside of Sample">BIBLIOGRAPHY</span></p>
<p class="toc-text"><span href="#/xhtml/end03" title="Link target outside of Sample">INDEX</span></p>
<p class="toc-text"><span href="#/xhtml/bio" title="Link target outside of Sample">ABOUT THE AUTHOR</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?2b036162